import { themeListAtom } from "@/shared/atoms";
import { themeType } from "@/shared/utils/constant";
import { IThemeData } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import { useEffect, useMemo } from "react";
import { get2 } from "../axios";
import { getValueByAll } from "../utils/helpers";
import useFranchiseHook from "./useFranchiseHook";

const useThemesHook = () => {
  const [franchiseId] = useFranchiseHook();
  const setThemeListAtom = useSetAtom(themeListAtom);

  const query = useQuery({
    queryKey: ["themes", franchiseId],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/websites/themes/${franchiseId}`),
  });

  const data = useMemo(() => {
    if (query.data) {
      const retVal = {
        custom: [],
        default: [],
      };
      Object.keys(query.data).forEach((key) => {
        let ret = {
          theme: {},
        };
        if (query.data[key].length) {
          query.data[key].map((item) => {
            Object.keys(item).forEach((k) => {
              const val = getValueByAll(item[k]);
              if (k.includes("color")) {
                ret.theme = {
                  ...ret.theme,
                  [k]: val,
                };
              } else {
                ret = { ...ret, [k]: val };
              }
            });

            retVal[key].push(ret);
          });
        }
      });
      return retVal as IThemeData;
    }
  }, [query.data]);

  useEffect(() => {
    if (data) {
      const defaultThemes = data.default.map((item) => ({
        ...item,
        themeType: themeType.DEFAULT,
      }));
      const customThemes = data.custom.map((item) => ({
        ...item,
        themeType: themeType.CUSTOM,
      }));
      setThemeListAtom([...defaultThemes, ...customThemes]);
    }
  }, [data, setThemeListAtom]);

  return { data, query };
};

export default useThemesHook;
